import type { MailboxInfo } from 'owa-client-types';
import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';
import getModuleContextMailboxInfoStore from '../store/moduleContextMailboxInfoStore';

export default function getModuleContextMailboxInfo(): MailboxInfo {
    return (
        getModuleContextMailboxInfoStore()?.moduleContextMailboxInfo ??
        getSelectedAccountMailboxInfo()
    );
}
